<div class="doc-notification verification" [ngClass]="{ error: haveError, success: !haveError && !isLoading }" *ngIf="saxoWorking">
  <ng-container *ngIf="isLoading; else showResult">
    <img id="logo" src="/assets/images/icons/yellow-inyova.svg" alt="logo" />
    <p *ngIf="isLoading && !passMinute">
      <ng-container *ngIf="appLocation !== 'ch'; else showCountdown">
        {{ 'idnow_start.error.is_loading.p1' | translate }} {{ 'idnow_start.error.is_loading.p2' | translate }}
      </ng-container>
      <ng-template #showCountdown>
        {{ 'idnow_start.error.is_loading.p3' | translate: { seconds: oneMinuteCountDown } }}
      </ng-template>
    </p>
    <p *ngIf="isLoading && passMinute">{{ 'idnow_start.error.is_loading.longer' | translate }}</p>
  </ng-container>
  <ng-template #showResult>
    <span [ngClass]="haveError ? 'icon-i-close-circle' : 'icon-i-checkmark-circle'"></span>
    <p>{{ (haveError ? 'idnow_start.error.noDocuments' : 'idnow_start.documents') | translate }}</p>
  </ng-template>
</div>
<div class="white-box">
  <h3>{{ 'steps.id4.sub3' | translate }}</h3>
  <p>{{ 'idnow_intro.whats_next.nearly' | translate }}</p>
  <ng-container *ngIf="documents.length && !isLoading && !haveError; else notLoadedDocuments">
    <ul class="document-list verification">
      <li *ngFor="let document of documents">
        <a (click)="onDownloadDocs(document)" download>
          <ng-container *ngIf="appLocation === 'ch'; else showDETitle"> {{ document.attributes.translated_title }} (PDF) </ng-container>
          <ng-template #showDETitle>
            <ng-container *ngIf="document.type_id === DOCUMENT_TYPE_ID.contract"
              >{{ 'contract.document.introduction' | translate }} (PDF)</ng-container
            >
            <ng-container *ngIf="document.type_id === DOCUMENT_TYPE_ID.intro">{{ 'contract.document.yova' | translate }} (PDF)</ng-container>
          </ng-template>
          <span class="icon-i-download"></span>
        </a>
      </li>

      <ng-container *ngIf="staticDocs.initialized">
        <li *ngFor="let document of staticDocs.docs">
          <a (click)="onDownloadStaticDocs(document)" title="{{ document.attributes.title }}" download>
            {{ document.attributes.title }} (PDF)
            <span class="icon-i-download"></span>
          </a>
        </li>
      </ng-container>
    </ul>
  </ng-container>
  <ng-template #notLoadedDocuments>
    <ul class="document-list loading" [ngClass]="{ error: haveError || !saxoWorking }">
      <li *ngFor="let i of [1, 2, 3]">
        <span></span>
      </li>
    </ul>
  </ng-template>
  <ng-content></ng-content>
</div>
